export const batchUploadCrumbs = [
  {
    title: "Rent reporting",
    href: "/rent-reporting"
  },
  {
    title: "Upload CSV",
    href: "/rent-reporting/upload"
  }
];
